import type { CrudAdapter } from '@botto/core';
import { useCrudDataSource } from '@botto/core';
import { tariffsApi } from '../client';
import type { Transaction } from '../types';

export interface TransactionListFilters {
  user_id?: number | null;
}

const filters: TransactionListFilters = {};

export function setTransactionListFilters(next: TransactionListFilters): void {
  Object.assign(filters, next);
}

/**
 * Transactions are read-only from the admin UI even though the API exposes
 * POST/PUT — those are reserved for the billing pipeline.
 */
export const transactionsAdapter: CrudAdapter<Transaction, never, never> = {
  async list({ offset, limit, sortName, sortDirection }) {
    const { data, error } = await tariffsApi.GET('/transactions/', {
      params: {
        query: {
          offset,
          limit,
          'sort.name': sortName ?? 'timestamp',
          'sort.direction': (sortDirection ?? 'desc') as 'asc' | 'desc',
          user_id: filters.user_id ?? undefined,
        },
      },
    });
    if (error) throw error;
    return { items: data?.items ?? [], total: data?.total ?? 0 };
  },
};

export const transactionsStore = useCrudDataSource(transactionsAdapter);
